import { z } from 'zod';

import { ChildGenderEnum } from './childUtilityInterfaces.ts';

export const ChildDetailsZod = z.object({
  ageInYearsAndMonths: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  birthDate: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  chronicIllness: z.array(z.string()),
  cluster: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  cognitiveAgeGroup: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  community: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  compassId: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  correspondenceLanguage: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  country: z.string().nullable().optional(),
  education: z.object({
    academicPerformance: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    formalLevel: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    gradeLevel: z.object({
      local: z
        .string()
        .nullable()
        .optional()
        .transform((val) => val || ''),
      us: z
        .string()
        .nullable()
        .optional()
        .transform((val) => val || ''),
    }),
    majorOrCourseOfStudy: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    notEnrolledInEducationReason: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
  }),
  fieldOffice: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  fundType: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  gender: z.enum([ChildGenderEnum.Female, ChildGenderEnum.Male]),
  globalId: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  hangul: z.object({
    name: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    preferred: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
  }),
  householdDuty: z.array(z.string()),
  icp: z.object({
    country: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    id: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
  }),
  imageUrl: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  interests: z.object({
    christianActivityName: z.array(z.string()),
    favoriteProjectActivity: z.array(z.string()),
    favoriteSchoolSubject: z.array(z.string()),
    thingsILike: z.array(z.string()),
  }),
  isInHivAffectedArea: z
    .boolean()
    .nullable()
    .optional()
    .transform((val) => val || false),
  isBirthDateEstimated: z
    .boolean()
    .nullable()
    .optional()
    .transform((val) => val || false),
  isOrphan: z
    .boolean()
    .nullable()
    .optional()
    .transform((val) => val || false),
  isSpecialNeeds: z
    .boolean()
    .nullable()
    .optional()
    .transform((val) => val || false),
  lastPhotoDate: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  lastReviewDate: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  localId: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  localNumber: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  name: z.object({
    first: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    preferred: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
  }),
  physicalDisability: z.array(z.string()),
  plannedCompletion: z.object({
    date: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
    dateChangeReason: z
      .string()
      .nullable()
      .optional()
      .transform((val) => val || ''),
  }),
  primaryCaregiver: z.object({
    name: z
      .string()
      .optional()
      .nullable()
      .transform((val) => val || ''),
  }),
  programDeliveryType: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  recordType: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  reviewStatus: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  sourceKit: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  sponsorshipStatus: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  state: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  status: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  vocationalTrainingType: z
    .string()
    .nullable()
    .optional()
    .transform((val) => val || ''),
  householdList: z.array(
    z.object({
      femaleGuardian: z.object({
        employmentStatus: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
        occupation: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
      }),
      household: z.object({
        id: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
        name: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
      }),
      householdMemberList: z.array(
        z.object({
          globalId: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          localId: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          householdMemberName: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          householdMemberRole: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          isCaregiver: z
            .boolean()
            .nullable()
            .optional()
            .transform((val) => val || false),
          isPrimaryCaregiver: z
            .boolean()
            .nullable()
            .optional()
            .transform((val) => val || false),
        }),
      ),
      maleGuardian: z.object({
        employmentStatus: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
        occupation: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
      }),
      parents: z.object({
        naturalFather: z.object({
          isAlive: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          isLivingWithChild: z
            .boolean()
            .nullable()
            .optional()
            .transform((val) => val || false),
        }),
        naturalMother: z.object({
          isAlive: z
            .string()
            .nullable()
            .optional()
            .transform((val) => val || ''),
          isLivingWithChild: z
            .boolean()
            .nullable()
            .optional()
            .transform((val) => val || false),
        }),
        maritalStatus: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
        together: z
          .string()
          .nullable()
          .optional()
          .transform((val) => val || ''),
      }),
      siblings: z.object({
        numberOfBrothers: z
          .number()
          .nullable()
          .optional()
          .transform((val) => val || 0),
        numberOfSiblingChildren: z
          .number()
          .nullable()
          .optional()
          .transform((val) => val || 0),
        numberOfSisters: z
          .number()
          .nullable()
          .optional()
          .transform((val) => val || 0),
      }),
      youthHeadedHousehold: z
        .boolean()
        .nullable()
        .optional()
        .transform((val) => val || false),
      revisedValues: z
        .string()
        .nullable()
        .optional()
        .transform((val) => val || ''),
      sourceKit: z
        .string()
        .nullable()
        .optional()
        .transform((val) => val || ''),
    }),
  ),
});

export const ChildAvailabilityZod = ChildDetailsZod.pick({
  birthDate: true,
  state: true,
  gender: true,
  globalId: true,
  fieldOffice: true,
  imageUrl: true,
  icp: true,
  localId: true,
  localNumber: true,
  name: true,
  isInHivAffectedArea: true,
  isOrphan: true,
  isSpecialNeeds: true,
}).extend({
  age: z.number().nullable(),
  minDaysWaiting: z.number().nullable(),
  priorityScore: z.number(),
  sourceCode: z.string().nullable().optional(),
  waitingSinceDate: z
    .string()
    .nullable()
    .transform((val) => val || ''),
});
